<template>
  <Modal
    class-name="approval-search-advanced-modal"
    :title="$t('global.advancedSearch')"
    v-model="visible"
    :mask-closable="false"
    @on-cancel="onCancel"
  >
    <Form
      ref="formRef"
      style="min-height: 100px"
      :label-width="$i18n.locale === 'en' ? 170 : 100"
    >
      <FormItem
        v-for="item in componentTypes"
        :key="item.templateCode"
        :label="
          item.type === 'PHONE' ? $t(`approval.${item.props.mode}`) : item.name
        "
      >
        <!-- 单行文本、当前地址、自动编号 -->
        <Input
          v-model="item.value"
          :placeholder="$t('i.textPlaceholder')"
          clearable
          v-if="
            $_.includes(
              ['SINGLE_INPUT', 'TIME_LOCATION', 'AUTO_NUMBER'],
              item.type
            )
          "
        />
        <!-- 多行文本 -->
        <Input
          v-model="item.value"
          type="textarea"
          :placeholder="$t('i.textPlaceholder')"
          clearable
          v-if="item.type === 'TEXTAREA'"
        />
        <!-- 数字、金额、计算公式 -->
        <InputNumber
          v-model="item.value"
          :placeholder="$t('i.textPlaceholder')"
          clearable
          v-if="
            $_.includes(
              ['NUMBER_INPUT', 'AMOUNT_INPUT', 'CALCULATE'],
              item.type
            )
          "
        />
        <!-- 单选 -->
        <RadioGroup
          v-model="item.value"
          v-if="item.type === 'RADIO' && item.componentType === 'RADIO'"
        >
          <Radio
            v-for="radio in item.props ? item.props.options : []"
            :key="radio.key"
            :label="radio.key"
          >
            {{ radio.value }}
          </Radio>
        </RadioGroup>
        <!-- 工作性质 -->
        <RadioGroup
          v-model="item.value"
          v-if="
            item.type === 'RADIO' &&
            item.componentType ===
              'COMPONENT_RECRUITMENT_JOB_POSITION-RADIO_NATURE_OF_WORK'
          "
        >
          <Radio
            v-for="radio in natureOfWorKs"
            :key="radio.value"
            :label="radio.value"
          >
            {{ $t(radio.label) }}
          </Radio>
        </RadioGroup>
        <!-- 多选 -->
        <Select
          class="approval-search-select"
          v-model="item.value"
          :placeholder="$t('i.select.placeholder')"
          clearable
          multiple
          v-if="item.type === 'SELECT'"
        >
          <Option
            v-for="select in item.props ? item.props : []"
            :key="select.key"
            :value="select.key"
            :label="select.value"
          />
        </Select>
        <!-- 日期 -->
        <template v-if="item.type === 'DATE_PICKER'">
          <template v-if="item.props && item.props.format">
            <TimePicker
              format="HH:mm"
              :placeholder="$t('i.select.placeholder')"
              :editable="false"
              clearable
              v-model="item.value"
              v-if="item.props.format === 'hh:ss'"
            ></TimePicker>
            <DatePicker
              :type="getDatePickerType(item.props.format)"
              :placeholder="$t('i.select.placeholder')"
              clearable
              :editable="false"
              :format="item.props.format"
              :value="item.value"
              @on-change="
                ($event) => {
                  item.value = $event;
                }
              "
              v-else
            />
          </template>
          <DatePicker
            type="daterange"
            :placeholder="$t('i.select.placeholder')"
            clearable
            :editable="false"
            :value="item.value"
            @on-change="
              ($event) => {
                item.value = $event;
              }
            "
            v-else
          />
        </template>
        <!-- 补卡套件-补打卡时间点type类型应为DATE_PICKER，而不是DATE_RANGE_PICKER-->
        <DatePicker
          type="datetime"
          :placeholder="$t('i.select.placeholder')"
          clearable
          :editable="false"
          format="yyyy-MM-dd HH:mm"
          :value="item.value"
          @on-change="
            ($event) => {
              item.value = $event;
            }
          "
          v-if="
            item.componentType ===
              'COMPONENT_CHECK_IN_RECORD-DATE_RANGE_PICKER' &&
            item.type === 'DATE_RANGE_PICKER'
          "
        />
        <!-- 日期范围 -->
        <template
          v-if="
            item.type === 'DATE_RANGE_PICKER' && item.props && item.props.format
          "
        >
          <TimePicker
            type="timerange"
            format="HH:mm"
            :placeholder="$t('i.select.placeholder')"
            :editable="false"
            clearable
            v-model="item.value"
            v-if="item.props.format === 'hh:ss'"
          ></TimePicker>
          <Row
            class="range-row"
            type="flex"
            align="middle"
            justify="space-between"
            v-else-if="item.props.format === 'yyyy-MM'"
          >
            <FormItem
              :show-message="false"
              :error="
                monthRangeError && item.value && !item.value[0] ? 'error' : ''
              "
            >
              <DatePicker
                type="month"
                :placeholder="$t('i.select.placeholder')"
                clearable
                :editable="false"
                :value="item.value && item.value[0]"
                :options="{
                  disabledDate: (value) => dateDisabledDate(item, value, 1)
                }"
                @on-change="(value) => onDateRangeChange(item, value, 0)"
              />
            </FormItem>
            <span>-</span>
            <FormItem
              :show-message="false"
              :error="
                monthRangeError && item.value && !item.value[1] ? 'error' : ''
              "
            >
              <DatePicker
                type="month"
                :placeholder="$t('i.select.placeholder')"
                clearable
                :editable="false"
                :value="item.value && item.value[1]"
                :options="{
                  disabledDate: (value) => dateDisabledDate(item, value, 0)
                }"
                @on-change="(value) => onDateRangeChange(item, value, 1)"
              />
            </FormItem>
          </Row>
          <DatePicker
            :type="
              item.props.format === 'yyyy-MM-dd' ? 'daterange' : 'datetimerange'
            "
            :format="item.props.format"
            :placeholder="$t('i.select.placeholder')"
            clearable
            :editable="false"
            :value="item.value"
            @on-change="
              ($event) => {
                item.value = $event;
              }
            "
            v-else
          />
        </template>
        <!-- 员工选择 -->
        <Select
          class="approval-search-select"
          v-model="item.value"
          :placeholder="$t('i.select.placeholder')"
          clearable
          :multiple="item.props && item.props.multi === 'true'"
          filterable
          filter-by-label
          :remote-method="onEmployeeSearch"
          :loading="empSearchLoading"
          @on-open-change="
            (status) => onEmpDepOpenChange(status, item.value, item.type)
          "
          v-if="item.type === 'SELECTED_EMPLOYEE'"
        >
          <Option
            v-for="select in employees"
            :key="select.id"
            :value="select.id"
            :label="select.employeeWorkInfo.displayName"
          />
        </Select>
        <!-- 部门选择 -->
        <Select
          class="approval-search-select"
          v-model="item.value"
          :placeholder="$t('i.select.placeholder')"
          clearable
          :multiple="item.props && item.props.multi === 'true'"
          filterable
          filter-by-label
          :remote-method="onDepartmentSearch"
          :loading="depSearchLoading"
          @on-open-change="
            (status) => onEmpDepOpenChange(status, item.value, item.type)
          "
          v-if="item.type === 'SELECTED_DEPARTMENT'"
        >
          <Option
            v-for="select in departments"
            :key="select.id"
            :value="select.id"
            :label="select.name"
          />
        </Select>
        <!-- 关联审批单 -->
        <Select
          class="approval-search-select"
          v-model="item.value"
          :placeholder="$t('i.select.placeholder')"
          clearable
          multiple
          filterable
          filter-by-label
          :remote-method="onAssociatedFormSearch"
          :loading="associatedFormSearchLoading"
          @on-open-change="(status) => onAFOpenChange(status, item.value)"
          v-if="item.type === 'ASSOCIATED_FORM'"
        >
          <Option
            v-for="select in associatedForms"
            :key="select.id"
            :value="select.id"
            :label="`${select.approval.title}(${select.id})`"
          />
        </Select>
        <!-- 手机号、电话 -->
        <template v-if="item.type === 'PHONE'">
          <Input
            v-model="item.value"
            :placeholder="$t('i.textPlaceholder')"
            v-if="item.props.mode === 'phone'"
          >
            <Select v-model="mobilePrefix" slot="prepend" style="width: 100px">
              <Option
                v-for="select in areaCodeList"
                :key="select.value"
                :value="`+${select.value}`"
                :label="`+${select.value}`"
              >
                {{ select.key }}+{{ select.value }}
              </Option>
            </Select>
          </Input>
          <Row type="flex" align="middle" v-else>
            <Input
              style="width: 96px"
              v-model="mobilePrefix"
              :placeholder="$t('i.textPlaceholder')"
            />
            -
            <Input
              style="width: calc(100% - 102px)"
              v-model="item.value"
              :placeholder="$t('i.textPlaceholder')"
            />
          </Row>
        </template>
        <!-- 请假类型 -->
        <Select
          class="approval-search-select"
          v-model="item.value"
          :placeholder="$t('i.select.placeholder')"
          clearable
          filterable
          filter-by-label
          v-if="item.componentType === 'COMPONENT_LEAVE-RADIO'"
        >
          <Option
            v-for="select in leaveTypes"
            :key="select.id"
            :value="select.id"
            :label="select.name"
          />
        </Select>
        <!-- 加班类型 -->
        <Select
          class="approval-search-select"
          v-model="item.value"
          :placeholder="$t('i.select.placeholder')"
          clearable
          filterable
          filter-by-label
          v-if="item.componentType === 'COMPONENT_OVERTIME-RADIO'"
        >
          <Option
            v-for="select in item.props"
            :key="select.value"
            :value="select.value"
            :label="select.name"
          />
        </Select>
        <!-- 加班补偿方式 -->
        <Select
          class="approval-search-select"
          v-model="item.value"
          :placeholder="$t('i.select.placeholder')"
          clearable
          filterable
          filter-by-label
          v-if="item.componentType === 'COMPONENT_OVERTIME-COMPENSATION_RADIO'"
        >
          <Option
            v-for="value in compensations"
            :key="value"
            :value="value"
            :label="$t(`approval.${value}`)"
          />
        </Select>
        <!-- 外出类型 -->
        <Select
          class="approval-search-select"
          v-model="item.value"
          :placeholder="$t('i.select.placeholder')"
          clearable
          filterable
          filter-by-label
          v-if="item.componentType === 'COMPONENT_OUTSIDE_WORK-RADIO'"
        >
          <Option
            v-for="select in item.props"
            :key="select.value"
            :value="select.value"
            :label="select.name"
          />
        </Select>
      </FormItem>
    </Form>
    <Spin fix v-if="loading" style="border-radius: 4px">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>

    <Row
      type="flex"
      align="middle"
      justify="end"
      :gutter="12"
      class="modal-footer"
      slot="footer"
    >
      <Col>
        <Button @click="onCancel">{{ $t('btn.cancel') }}</Button>
      </Col>
      <Col>
        <Button @click="onRepossess">{{ $t('i.table.resetFilter') }}</Button>
      </Col>
      <Col>
        <Button type="primary" @click="onOk">{{ $t('btn.done') }}</Button>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import natureOfWorKs from './data.js';
import currencyToAreaCode from '@/assets/js/currency-to-area-code';
export default {
  data() {
    this.oId = null;
    this.oComponentTypes = null;
    this.oMobilePrefix = null;
    this.associatedFormUrl = null;
    this.associatedFormParams = null;
    return {
      visible: false,
      componentTypes: [],
      loading: true,
      departments: [],
      employees: [],
      associatedForms: [],
      empSearchLoading: false,
      depSearchLoading: false,
      associatedFormSearchLoading: false,
      areaCodeList: [],
      mobilePrefix: null,
      leaveTypes: [],
      compensations: ['NONE', 'SALARY', 'TUNE', 'CHOOSE_SELF'],
      monthRangeError: false
    };
  },
  computed: {
    natureOfWorKs() {
      return natureOfWorKs;
    }
  },
  methods: {
    // 获取手机区号列表
    async getMobilePrefixList(mode) {
      const res = await this.$http(
        'get',
        'public/dictionaries/area_code',
        { code: 'area_code' },
        true
      );
      this.areaCodeList = res.data.dictValues;
      if (mode === 'phone' || mode === 'phone_tel') {
        try {
          const areaCode = _.find(this.areaCodeList, (v) => {
            const extendedValue =
              v.extendedValue && JSON.parse(v.extendedValue);
            return (
              extendedValue &&
              extendedValue.countryCode ===
                currencyToAreaCode[this.$store.state.team.country.code]
            );
          });
          const defaultValue =
            process.env.VUE_APP_REGION === 'yoov' ? '852' : '86';
          const mobilePrefix = areaCode ? `${areaCode.value}` : defaultValue;
          this.mobilePrefix = `+${mobilePrefix}`;
          this.oMobilePrefix = `+${mobilePrefix}`;
        } catch (e) {
          console.log(e);
        }
      }
    },
    open({ id, type }) {
      this.visible = true;
      if (!this.oId || (this.oId && this.oId !== id)) {
        this.oId = id;
        this.getDetail(id);
      }
      const urls = {
        approval_forms: 'mobile/forms/approval_forms_associated', // 待我审批
        had_approved: 'mobile/forms/had_approved_associated', // 我已审批
        me: 'mobile/forms/me_associated', // 我发起的
        copied_forms: 'mobile/forms/copied_forms_associated' // 抄送我的
      };
      this.associatedFormUrl = urls[type];
    },
    // 获取表单
    async getDetail(id) {
      try {
        this.loading = true;
        const res = await this.$http('get', `mobile/approvals/${id}`, {}, true);
        this.componentTypes = res.data.extension
          ? this.initComponentTypes(res.data.extension.digest)
          : [];
        this.oComponentTypes = _.cloneDeep(this.componentTypes);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    initComponentTypes(digest) {
      try {
        return _.map(digest, (v) => {
          if (v.props) {
            v.props = JSON.parse(v.props);
          }
          const types = _.split(v.templateCode, '-');
          let type = types[0];
          const reg = new RegExp('^[0-9a-z]*$');
          if (types[2]) {
            type = `${types[0]}-${types[2]}`;
          } else if (!reg.test(types[1])) {
            type = v.templateCode;
          }
          this.$set(v, 'componentType', type);
          // 请假套件
          if (type === 'COMPONENT_LEAVE-RADIO') {
            this.getLeaveTypes();
          }
          if (v.type === 'SELECTED_EMPLOYEE') {
            this.getEmployees();
          }
          if (v.type === 'SELECTED_DEPARTMENT') {
            this.getDepartments();
          }
          if (v.type === 'ASSOCIATED_FORM') {
            this.associatedFormParams = {
              approvalId: this.oId,
              templateCode: v.templateCode
            };
            this.getAssociatedForms();
          }
          if (v.type === 'PHONE') {
            this.getMobilePrefixList(v.props.mode);
          }
          if (
            _.includes(['DATE_PICKER', 'DATE_RANGE_PICKER'], v.type) &&
            v.props &&
            v.props.format === 'yyyy-MM-dd hh:ss'
          ) {
            v.props.format = 'yyyy-MM-dd HH:mm';
          }
          return v;
        });
      } catch (e) {
        console.log(e);
      }
    },
    // 设置日期选择器类型
    getDatePickerType(format) {
      let type = 'date';
      switch (format) {
        case 'yyyy-MM-dd HH:mm':
          type = 'datetimerange';
          break;
        case 'yyyy-MM':
          type = 'month';
          break;
      }
      return type;
    },
    // 时间区间、日期区间
    onDateRangeChange(item, value, index) {
      (!item.value ? (item.value = ['', '']) : item.value)[index] = value;
      if (item.value[0] && item.value[1]) {
        this.monthRangeError = false;
      }
    },
    // 时间区间、日期区间不可选设置
    dateDisabledDate(item, value, index) {
      if (value && item.value && item.value[index]) {
        const valueOf = value.valueOf();
        const itemValueOf = this.$moment(item.value[index]).valueOf();
        if (index === 0) {
          return valueOf < itemValueOf;
        } else {
          return valueOf > itemValueOf;
        }
      }
    },
    // 搜索员工
    onEmployeeSearch(query) {
      this.empSearchLoading = true;
      this.employeeSearch(query);
    },
    employeeSearch: _.debounce(function (query) {
      this.getEmployees({
        search: query
      });
    }, 300),
    // 搜索部门
    onDepartmentSearch(query) {
      this.depSearchLoading = true;
      this.departmentSearch(query);
    },
    departmentSearch: _.debounce(function (query) {
      const newQuery = query.substring(0, 50);
      this.getDepartments({
        search: newQuery
      });
    }, 300),
    // 获取员工
    async getEmployees(params = {}) {
      const res = await this.$http('get', 'mobile/employees', params, true);
      this.employees = res.data.content;
      this.empSearchLoading = false;
    },
    // 获取部门
    async getDepartments(params = {}) {
      const res = await this.$http('get', 'mobile/departments', params, true);
      this.departments = res.data.content;
      this.depSearchLoading = false;
    },
    // 员工、部门下拉框关闭时
    onEmpDepOpenChange(status, value, type) {
      if (!status && !value) {
        if (type === 'SELECTED_EMPLOYEE') {
          this.getEmployees();
        } else {
          this.getDepartments();
        }
      }
    },
    // 搜索关联表单
    onAssociatedFormSearch(query) {
      this.associatedFormSearchLoading = true;
      this.associatedFormSearch(query);
    },
    associatedFormSearch: _.debounce(function (query) {
      this.getAssociatedForms(query);
    }, 300),
    // 获取关联表单
    async getAssociatedForms(query) {
      const params = _.cloneDeep(this.associatedFormParams);
      if (query) {
        params.search = query;
      }
      const res = await this.$http('get', this.associatedFormUrl, params, true);
      this.associatedForms = res.data;
      this.associatedFormSearchLoading = false;
    },
    // 关联表单下拉框关闭时
    onAFOpenChange(status, value) {
      if (!status && !value) {
        this.getAssociatedForms();
      }
    },
    // 获取请假类型
    async getLeaveTypes() {
      const res = await this.$http(
        'get',
        'mobile/leave_types/all',
        {},
        true,
        'attendance'
      );
      this.leaveTypes = res.data;
    },
    // 取消
    onCancel() {
      this.visible = false;
      this.mobilePrefix = this.oMobilePrefix;
      this.componentTypes = [];
      this.onRepossess();
    },
    // 重置表单
    onRepossess() {
      this.mobilePrefix = this.oMobilePrefix;
      this.componentTypes = _.cloneDeep(this.oComponentTypes);
    },
    // 判断value是否有值
    isValue(value) {
      if (_.isArray(value)) {
        return _.every(value, (e) => this.isValue(e));
      } else {
        return value !== '' && !_.isNil(value);
      }
    },
    // 确定
    onOk() {
      const monthRange = _.find(
        this.componentTypes,
        (f) =>
          f.type === 'DATE_RANGE_PICKER' &&
          f.props &&
          f.props.format === 'yyyy-MM'
      );
      if (
        monthRange &&
        monthRange.value &&
        ((monthRange.value[0] && !monthRange.value[1]) ||
          (!monthRange.value[0] && monthRange.value[1]))
      ) {
        this.monthRangeError = true;
        return false;
      } else if (this.monthRangeError) {
        this.monthRangeError = false;
      }
      const filterValue = _.filter(this.componentTypes, (v) =>
        this.isValue(v.value)
      ).map((m) => {
        let value = m.value;
        if (m.type === 'PHONE') {
          value = JSON.stringify([this.mobilePrefix, m.value]);
        } else if (_.isArray(m.value)) {
          value = JSON.stringify(m.value);
        } else if (
          _.includes(
            ['DATE_PICKER', 'SELECTED_EMPLOYEE', 'SELECTED_DEPARTMENT'],
            m.type
          ) &&
          !_.isArray(m.value)
        ) {
          value = JSON.stringify([m.value]);
        } else if (
          // 补卡套件-补打卡时间点type类型应为DATE_PICKER，而不是DATE_RANGE_PICKER
          m.componentType === 'COMPONENT_CHECK_IN_RECORD-DATE_RANGE_PICKER' &&
          m.type === 'DATE_RANGE_PICKER'
        ) {
          value = JSON.stringify([`${m.value}:00`]);
        }
        return {
          templateCode: m.templateCode,
          value: value
        };
      });
      this.$emit('on-ok', filterValue);
      this.visible = false;
    }
  }
};
</script>
<style lang="less">
.approval-search-advanced-modal {
  .ivu-input-wrapper,
  .ivu-input-number,
  .ivu-radio-group,
  .ivu-select,
  .ivu-date-picker,
  .ivu-select .ivu-select-dropdown {
    width: 100%;
  }

  .range-row {
    .ivu-form-item {
      width: 48%;
    }
  }
}
</style>
